var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8.4 8.4",
    style: {
      enableBackground: "new 0 0 8.4 8.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#242E38;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,8.4c-1,0-1.9-0.2-2.8-0.7S3.2,6.7,2.5,5.9S1.2,4.3,0.7,3.4S0,1.5,0,0.6c0-0.2,0.1-0.3,0.2-0.4 C0.3,0.1,0.4,0,0.6,0h1.7c0.1,0,0.2,0,0.3,0.1s0.2,0.2,0.2,0.3l0.3,1.5c0,0.1,0,0.2,0,0.3C3.1,2.4,3,2.5,3,2.5L1.8,3.7 c0.4,0.6,0.8,1.2,1.3,1.7s1,0.9,1.6,1.2l1.1-1.1C6,5.4,6.1,5.3,6.2,5.3c0.1,0,0.2,0,0.3,0l1.4,0.3c0.1,0,0.3,0.1,0.3,0.2 C8.4,5.9,8.4,6,8.4,6.2v1.7c0,0.2-0.1,0.3-0.2,0.4C8.1,8.4,8,8.4,7.8,8.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/Contacts.bd1538c661d82fea22a756c41d80a08a.svg";
export { ForwardRef as ReactComponent };